import { render, staticRenderFns } from "./turn-record.vue?vue&type=template&id=717c4390&scoped=true"
import script from "./turn-record.vue?vue&type=script&lang=ts"
export * from "./turn-record.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717c4390",
  null
  
)

export default component.exports